import type { Location } from '@core/Router/locations';
import { lazy } from 'react';

const LaboratoryAdmin = lazy(() =>
    import(/* webpackChunkName: "lab" */ '@lab/ui/LaboratoryAdmin').then(m => ({ default: m.LaboratoryAdmin })),
);

export const labLocations: Location[] = [
    {
        url: '/laboratory-admin',
        Component: LaboratoryAdmin,
    },
];
